{
    "de-DE": {
        "MODULEID": "Payment.WEB",
        "ERROR_CODES": {},
        "PAGENOTFOUND": {
            "MESSAGE": "404 - Seite nicht gefunden",
            "MESSAGEEXPLANATION": "Keine Sorge, wir helfen Ihnen, dorthin zu gelangen, wo Sie hin müssen.\r\nMelden Sie sich hierzu beim Helpdesk!",
            "USECASESELECTOR": "Zur Übersicht"
        },
        "APPLICATION": {
            "TITLE": "VEGA Online-Zahlung"
        },
        "PAYMENT": {
            "ANGULAR-TRANSLATION": {
                "EXECUTE": "Webrequest ausführen"
            },
            "YOUR_ORDER": "Ihre Bestellung",
            "ORDER_NUMBER": "Bestellnummer",
            "INVOICE_NUMBER": "Rechnungsnummer",
            "CUSTOMER_REFERENCE": "Auftragsreferenz",
            "POSITIONS": "Positionen",
            "QUANTITY": "Menge",
            "TOTAL_AMOUNT": "Gesamtpreis",
            "PAYMENT_OPTIONS": "Zahlungsoptionen",
            "PAY_NOW": "Jetzt bezahlen",
            "DISCLAIMER": "Kreditkartendaten werden direkt an Stripe übermittelt und von VEGA weder verarbeitet noch speichert.",
            "LOADING_PAYMENT": "Zahlungsinformationen werden geladen...",
            "NOT_PAID": "Nicht bezahlt",
            "CANCELED": "Storniert",
            "PAID": "Bezahlt",
            "ERROR": "Fehler",
            "PROCESSING": "In Bearbeitung",
            "POS_NUMBER": "Pos.",
            "DESCRIPTION": "Beschreibung",
            "PRICE": "Preis",
            "UNIT_PRICE": "Einzelpreis",
            "TOTAL_PRICE": "Gesamtpreis",
            "INVOICE_DETAILS": "Rechnungsdetails",
            "PRICES": "Preise",
            "INVOICE_INFORMATIONS": "Rechnungsinformationen",
            "AMOUNT_OF_GOODS": "Warenwert",
            "SHIPPING_AND_PACKINGCOSTS": "Versand & Verpackungskosten",
            "INVOICE_NET_AMOUNT": "Rechnungsbetrag Netto",
            "VAT": "MwSt.",
            "INVOICE_AMOUNT": "Rechnungsbetrag Brutto",
            "INVOICE_TOTAL_AMOUNT": "Gesamtbetrag",
            "INVOICE_DATE": "Rechnungsdatum",
            "POWERED_BY": "Powered by",
            "TERMS": "Bedingungen",
            "PRIVACY": "Datenschutz",
            "SHOW_RECEIPT": "Beleg anzeigen",
            "YOUR_CONTACT": "Ihr Ansprechpartner",
            "ORDER_PREPERATION": "Auftragsbearbeitung",
            "PAYMENT_SUCCESSFULL": "Bezahlung abgeschlossen",
            "PAYMENT_SUCCESSFULL_INFO": "Die Bezahlung wurde erfolgreich verarbeitet. Sie können dieses Fenster nun schließen.",
            "CLOSE_WINDOW": "Fenster schließen",
            "PAYMENT_ALREADY_PAID": "Die Rechnung wurde bereits erfolgreich bezahlt.",
            "RECEIPT_INFO_MESSAGE": "Sie erhalten in kürze eine Zahlungsbestätigung per E-Mail.",
            "PAYMENT_PROCESSING": "Ihre Zahlung wird derzeit bearbeitet.",
            "PAYMENT_PROCESSING_MESSAGE": " Haben Sie etwas Geduld. Wir werden Ihnen eine E-Mail zusenden, wenn Ihre Zahlung erfolgreich war.",
            "PAYMENT_CANCELED": "Die Rechnung wurde storniert!",
            "PAYMENT_CANCELED_MESSAGE": "Bei Rückfragen wenden Sie sich bitte an Ihren Ansprechpartner.",
            "PAYMENT_FAILED": "Zahlung fehlgeschlagen!",
            "PAYMENT_FAILED_MESSAGE": "Es tut uns leid, während der Verarbeitung ihrer Zahlung ist ein Fehler aufgetreten. Bitte Versuchen Sie es zu einem späteren Zeitpunkt erneut.",
            "TRY_AGAIN": "Erneut versuchen",
            "UNEXPECTED_ERROR": "Es ist ein unerwarteter Fehler aufgetreten!",
            "TRY_AGAIN_LATER": "Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.",
            "INVOICE_NOT_FOUND": "Die angegebene Rechnung konnte nicht gefunden werden!",
            "INVOICE_NOT_FOUND_MESSAGE": "Bitte prüfen Sie die angegebene URL oder versuchen Sie es zu einem späteren Zeitpunkt erneut.",
            "SHOW_DETAILS": "Details anzeigen",
            "DISCOUNT_OF": "Abzüglich",
            "SKONTO": "Skonto",
            "ADVANCE_PAYMENT": "Anzahlung",
            "REMAINING_AMOUNT": "Restbetrag"
        },
        "OVERVIEW": {
            "PAYOUT_ID": "Payout-ID",
            "TRANSACTION_ID": "Transaktions-ID",
            "TRANSACTION_TYPE": "Transaktions-Art",
            "TRANSACTION_TYPE_REFUND": "Rückerstattung",
            "TRANSACTION_TYPE_CHARGE": "Zahlung",
            "TRANSACTION_TYPE_FEE": "Stripe Gebühr",
            "TRANSACTION_TYPE_NETWORK_COST": "Netzwerkgebühr",
            "TOTAL_AMOUNT": "Gesamtbetrag",
            "TOTAL_PAYOUT_AMOUNT": "Gesamter Auszahlungsbetrag",
            "CHARGE_ID": "Charge-ID",
            "AMOUNT": "Betrag",
            "INVOICE_AMOUNT": "Rechnungsbetrag",
            "CREATE_DATE": "Erstellungsdatum",
            "ORDER_ID": "Auftragsnummer",
            "INVOICE_ID": "Rechnungsnummer",
            "CUSTOMER_ID": "Kundennummer",
            "STARTDATE": "Startdatum",
            "ENDDATE": "Enddatum",
            "SEARCH": "Suchen",
            "PAID": "Bzahlstatus in TopVis",
            "CUSTOMER_REFERENCE": "Kundenreferenz",
            "COMPANY_NAME": "Firmenname",
            "LOADMORE": "Mehr laden",
            "LOADMORE_INFO": "Es sind noch weitere Auszahlungen verfügbar. Aufgrund langer Ladezeiten werden nicht sofort alle Daten geladen. Sie können entweder den angezeigten Datumsbereich anpassen oder auf 'Mehr laden' klicken, um weitere Einträge zu sehen."
        }
    }
}